import { User } from './user-model';

export function canAccessOrganization(user: User, organizationId: string): boolean {
  return (
    user.superuser || user.organizations.some((organization) => organization.id === organizationId)
  );
}

export function getAccessibleOrganizationId(user: User | null): string | null {
  if (!user) return null;

  const currentOrganizationId = user.current_organization?.id;
  if (currentOrganizationId && canAccessOrganization(user, currentOrganizationId)) {
    return currentOrganizationId;
  }

  return user.organizations[0]?.id ?? null;
}
